import {
  ReactNode,
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";

type GlobalProviderProps = {
  children: ReactNode;
};

type GlobalContext = {
  filterJobState: {
    title: string | null;
    level: string | null;
    experience_level: string | null;
    closed: string | null;
    jobposted: string | null;
    employment_type: string | null;
    start_date: string | null;
    end_date: string | null;
    work_model: string | null;
    sector: string | null;
    location_city: string | null;
    location_country: string | null;
  };
  filterTalent: {
    sector: string | null;
    experience: string | null;
    relocate: any | null;
    country: string | null;
    skills: string | null;
    jobTitle: string | null;
    visibility_score: string | null;
    gender: string | null;
  };
  filterFolderState: {
    title: string | null;
    location_country: string | null;
    location_city: string | null;
    gender: string | null;
    visibility_score: number | null;
    skills: string | null;
    experience_level: string | null;
    sector: string | null;
    relocate: number | null;
  };

  setFilterJobState: (state: any) => void;
  setFilterFolderState: (state: any) => void;
  setFilterTalent: (state: any) => void;
};

const theGlobalContext = createContext({} as GlobalContext);

export function useGlobalContext() {
  return useContext(theGlobalContext);
}

export function GlobalContextProvider({ children }: GlobalProviderProps) {
  const [filterJobState, setFilterJobState] = useState({
    title: null,
    level: null,
    experience_level: null,
    closed: null,
    start_date: null,
    end_date: null,
    work_model: null,
    location_country: null,
    location_city: null,
    employment_type: null,
    sector: null,
    jobposted: null,
  });

  const [filterFolderState, setFilterFolderState] = useState({
    title: null,
    location_country: null,
    location_city: null,
    gender: null,
    skills: null,
    experience_level: null,
    sector: null,
    relocate: null,
    visibility_score: null,
  });

  const [filterTalent, setFilterTalent] = useState({
    sector: null,
    experience: null,
    gender: null,
    country: null,
    skills: null,
    title: null,
    jobTitle: null,
    visibility_score: null,
    assessmentStatus: null,
    relocate: null,
  });

  


  return (
    <theGlobalContext.Provider
      value={{
        filterJobState,
        setFilterJobState,
        filterFolderState,
        setFilterFolderState,
        filterTalent,
        setFilterTalent,        
      }}
    >
      {children}
    </theGlobalContext.Provider>
  );
}
